module.exports = __webpack_public_path__ + "img/patient-protection.e90d511d.svg";